import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _styled from "styled-components";
var _excluded = ["isJobPositionOutsideItaly"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useNavigationContext } from '@restworld/utils-common';
import { Button, Title, JobFavoritePositionButton } from '../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PageInsiderNav = function PageInsiderNav(_ref) {
  var isJobPositionOutsideItaly = _ref.isJobPositionOutsideItaly,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var _useTranslation = useTranslation('job-position-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "ghost",
        icon: "ArrowLeftIcon",
        onClick: function onClick() {
          return router === null || router === void 0 ? void 0 : router.push('/cerco-lavoro');
        }
      }), /*#__PURE__*/_jsx(Title, {
        testId: "job-position-title",
        textColor: "black",
        variant: "h6-large",
        fontWeight: "semibold",
        content: t('job_title'),
        suffixIcon: isJobPositionOutsideItaly ? 'WorldIcon' : undefined
      }), /*#__PURE__*/_jsx(JobFavoritePositionButton, _objectSpread({}, rest))]
    })
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "page-insider-nav___StyledDiv",
  componentId: "sc-5ffzbl-0"
})({
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "@media (min-width: 1024px)": {
    "padding": "0px"
  }
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "page-insider-nav___StyledDiv2",
  componentId: "sc-5ffzbl-1"
})({
  "display": "flex",
  "width": "100%",
  "justifyContent": "space-between"
});